const data = {
  primaryColor: "#3F51B5",
  lightColor: true,
  title: "Calculator",
  category: "Tools",
  icon: "/images/app-icons/calculator.png",
  slogan: "Simple and advanced mathematical functions",
  shortDescription: "An application for calculating basic and advanced mathematical functions, including brackets, percentages, trigonometry, logarithms, exponential, and more, in a simple and user-friendly interface",
  fullDescription:
    "Calculator is an easy-to-use application that allows to perform simple and advanced mathematical calculations. With this application, you are able to perform basic calculations like addition, subtraction, multiplication, and division, or take advantage of more advanced features like trigonometric functions, logarithmic and exponential functions, pi, and factorial. Calculator has also ability calculate with brackets and percentages. Whether for school, work, or everyday use, Calculator makes calculations a breeze.",
  usesCases: [
    "Perform basic calculations such as addition, subtraction, multiplication, and division",
    "Do scientific operations such as trigonometric, logarithmic, and exponential functions",
  ],
  properties: [
    "Basic functions as addition, subtraction, multiplication and division",
    "Calculation with brackets and percentages",
    "Trigonometric functions such as sinus, cosines and tangent's",
    "Logarithmic and exponential functions",
    "Pi and factorial",
  ],
  services: [],
  pricing: "Free",
  android: {
    permissions: null,
    requirements:
      "This application does not need any special requirements to run.",
    requiredAndroidVersion: "5.0 and up",
    versioning: {
      releasedOn: new Date(2018, 9, 7),
      currentVersion: "1.3",
      updatedOn: new Date(2022, 1, 27),
    },
    availableOn: {
      googlePlayURL:
        "https://play.google.com/store/apps/details?id=cz.david_simak.calculator",
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    deviceCompatibility: {
      phone: true,
      tablet: true,
    },
    techInformation: {
      language: "Java 11",
      logging: "ACRA",
      database: null,
      integrations: [],
      libraries: [],
      plugins: [],
    },
    images: [
      {
        title: "Main screen",
        url: "/images/project-screenshots/calculator/calculator-android-1.png",
        description: null,
      },
      {
        title: "Main screen",
        url: "/images/project-screenshots/calculator/calculator-android-2.png",
        description: null,
      },
      {
        title: "Main screen",
        url: "/images/project-screenshots/calculator/calculator-android-3.png",
        description: null,
      },
      {
        title: "Main screen",
        url: "/images/project-screenshots/calculator/calculator-android-4.png",
        description: null,
      },
      {
        title: "Main screen",
        url: "/images/project-screenshots/calculator/calculator-android-5.png",
        description: null,
      },
    ],
  },
  frontend: null,
  backend: null,
};

class CalculatorProjectData {
  get() {
    return data;
  }

  getAsItem() {
    return {
      tag: "calculator",
      title: data.title,
      category: data.category,
      icon: data.icon,
      shortDescription: data.shortDescription,
      platform: {
        android: data.android !== null,
        frontend: data.frontend !== null,
        backend: data.backend !== null,
      },
    };
  }

  getIfCategoryIsMatched(categoryName) {
    if (categoryName === data.category) {
      return this.getAsItem();
    }

    return undefined;
  }
}

export default new CalculatorProjectData();
